export const CREATE_PAYROLL_WORK_ON_PROJECT = "CREATE_PAYROLL_WORK_ON_PROJECT";
export const FETCH_PAYROLL_WORK_ON_PROJECTS = "FETCH_PAYROLL_WORK_ON_PROJECTS";
export const EDIT_PAYROLL_WORK_ON_PROJECT = "EDIT_PAYROLL_WORK_ON_PROJECT";
export const DELETE_PAYROLL_WORK_ON_PROJECT = "DELETE_PAYROLL_WORK_ON_PROJECT";
